import React from 'react';

import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import FilledButton from 'components/application/buttons/FilledButton';
import TextButton from 'components/application/buttons/TextButton';
import ModalBox from 'components/application/ModalBox';

export default function BookingELearningNoCreditsModal({
  isOpen,
  setIsClosed,
}) {
  const { t: i18nT } = useTranslation('components', {
    keyPrefix: 'training.BookingELearningNoCreditsModal',
  });

  const { t: i18nTShared } = useTranslation('common', {
    keyPrefix: 'shared',
  });

  return (
    <ModalBox
      customFooter={
        <div className='modalbox__footer-actions modalbox__footer-actions--right'>
          <TextButton
            className='tw-mr-3'
            color='blue'
            onClick={setIsClosed}
            size='md'
          >
            {i18nTShared('cancel')}
          </TextButton>
          <FilledButton
            color='mint'
            id='intercom-launcher'
            onClick={setIsClosed}
          >
            {i18nT('button')}
          </FilledButton>
        </div>
      }
      isOpen={isOpen}
      mode='flexible'
      onClose={setIsClosed}
    >
      <div className='tw-p-8'>
        <h2 className='tw-mb-5 tw-mt-0 tw-p-0 tw-text-l tw-font-semibold tw-text-grey-900'>
          {i18nT('title')}
        </h2>
        <p className='tw-m-0'>{i18nT('description')}</p>
      </div>
    </ModalBox>
  );
}

BookingELearningNoCreditsModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  setIsClosed: PropTypes.func.isRequired,
};
